import createDataContext from './createDataContext';
// import IdleTimer from "react-idle-timer";
// import { useHistory } from "react-router-dom";
// import PaycomLogo from "../images/westjordan.png";
import baseURL from '../api.js';
import Cart from '../components/property/Cart.js';

var axios = require('axios');
var qs = require('qs');

const reducer = (state, action) => {
	switch (action.type) {
		case 'hydrate_terminal':
			const {
				logoURL,
				merchantID,
				merchantName,
				accountLabel,
				searchAccountStrict,
				parcelLabel,
				physicalAddressLabel,
				visibleFilters,
				customDisclaimer,
				customerAddressInSearch,
				customSearchTipDescription,
				verticalMarketLogo,
				enableCoris,
				amountEditable,
				breakdownBaseTaxInterestAndFees,
			} = action.payload;

			return {
				...state,
				merchant: {
					logoURL,
					merchantID,
					merchantName,
					accountLabel,
					searchAccountStrict,
					parcelLabel,
					physicalAddressLabel,
					visibleFilters,
					customDisclaimer,
					customerAddressInSearch,
					customSearchTipDescription,
					verticalMarketLogo,
					enableCoris,
					amountEditable,
					breakdownBaseTaxInterestAndFees,
				},
				appLoading: false,
				opIDValid: true,
			};
		case 'hydrate_error':
			return {
				...state,
				appLoading: false,
				hydrateError: true,
			};
		case 'op_error':
			return {
				...state,
				opIDValid: action.payload,
				appLoading: false,
			};
		default:
			return state;
	}
};
const refreshLightboxAndOpen = (dispatch) => async (enpartialpayment, cartCount) => {
	let op = null;
	const pathArray = window.location.pathname.split('/');
	console.log(pathArray);

	if (pathArray) {
		if (pathArray[1] === 'onetax') {
			op = pathArray[2];
		} else {
			op = pathArray[1];
		}
	}
	// localStorage.setItem('opID', op);
	// const intellipayResponse = await axios({
	// 	method: 'post',
	// 	url: `${baseURL()}`,
	// 	data: qs.stringify({
	// 		method: 'refreshLightbox',
	// 		params: `{}`,
	// 	}),
	// });

	// eval(intellipayResponse.data.lightbox);
	// console.log('what is the response', intellipayResponse);
	// if(intellipayResponse){
	// 	window.intellipay.onSubmit();
	// }

	// getLightbox({ opID: op });
	// const options = {
	// 	method: "POST",
	// 	headers: { "content-type": "application/x-www-form-urlencoded" },
	// 	data: qs.stringify({
	// 	  params: `{}`,
	// 	}),
	// 	withCredentials: true,
	// 	url:
	// 	  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
	// 		? "https://brandonshepherd.cpteller.com/api/onetaxapi.cfc?method=refreshLightbox"
	// 		: `https://${window.location.hostname}/api/onetaxapi.cfc?method=refreshLightbox`,
	//   };

	//   const intellipayResponse = await axios(options);

	// if (!intellipayResponse.data.session) {
	// 	let opID = localStorage.getItem("opID");

	// 	const hydrateTerminalResponse = await axios({
	// 		method: "post",
	// 		url:
	// 		process.env.NODE_ENV || process.env.NODE_ENV === "development"
	// 			? "https://brandonshepherd.cpteller.com/api/onetaxapi.cfc?method=refreshLightbox"
	// 			: `https://${window.location.hostname}/api/onetaxapi.cfc?method=refreshLightbox`,
	// 		data: qs.stringify({
	// 		method: "hydrateTerminal",
	// 		opID,
	// 		}),
	// 	});

	// 	console.log("REFRESH REPONSE", intellipayResponse.data.lightbox);
	// 	eval(intellipayResponse.data.lightbox);
	// } else {
	// 	console.log("REFRESH REPONSE no session", intellipayResponse.data.lightbox);
	// 	eval(intellipayResponse.data.lightbox);
	// }
	// window.intellipay = null;
	let opID = localStorage.getItem('opID');
	

	await axios({
		method: 'post',
		url: `${baseURL()}`,
		data: qs.stringify({
			method: 'hydrateTerminal',
			opID,
		}),
	});

    const options = {
		method: "POST",
		headers: { "content-type": "application/x-www-form-urlencoded" },
		data: qs.stringify({
		  params: `{}`,
		}),
		withCredentials: true,
		url:`https://${window.location.hostname}/api/onetaxapi.cfc?method=refreshLightbox`,
	  };

	const intellipayResponse = await axios(options);
	eval(intellipayResponse.data.lightbox);


	//Partial Payment Can only happen if one invoice at a time is being paid
	if(enpartialpayment && cartCount == 1){
		window.intellipay.enable("amount");
	} else{
		window.intellipay.disable("amount");
	}

	window.intellipay.onSubmit();

	// if (intellipayResponse.status === 200) {

		// const response = await axios({
		// 	method: "post",
		// 	url: `https://${window.location.hostname}/api/onetaxapi.cfc`,
		// 	data: qs.stringify({
		// 	  method: "hydrateTerminal",
		// 	  opID: op,
		// 	}),
		// 	withCredentials: true,
		// });

		// dispatch({
		// 	type: 'hydrate_terminal',
		// 	payload: response.data,
		// });

		// eval(intellipayResponse.responseText);
		// await getLightbox({ opID: op });



		
		// hydrateTerminal();


	// }
	// var rg = document.createRange();
	// document.documentElement.appendChild(
	// 	rg.createContextualFragment(intellipayResponse.data.lightbox)
	// );
	
	
	
}

const hydrateTerminal = (dispatch) => async () => {
	// if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
	//   dispatch({
	//     type: "hydrate_terminal",
	//     payload: {
	//       logoURL:
	//         "https://brandonshepherd.cpteller.com/onelink/static/media/intellipay-dark.ca3f7619.png",
	//       merchantID: 6443,
	//       merchantName: "Anuja - Test Site Fee CST",
	//     },
	//   });
	// } else {

	let op = null;
	const pathArray = window.location.pathname.split('/');
	console.log(pathArray);

	if (pathArray) {
		if (pathArray[1] === 'onetax') {
			op = pathArray[2];
		} else {
			op = pathArray[1];
		}
	}

	localStorage.setItem('opID', op);

	console.log(op);

	if (!op) {
		console.log('OPID does not exist in url param hydratePortal', op);
		console.log('op error');
		dispatch({ type: 'op_error', payload: false });
		return;
	}

	try {
		const response = await axios({
			method: 'post',
			url: `${baseURL()}`,
			data: qs.stringify({
				method: 'hydrateTerminal',
				opID: op,
			}),
			withCredentials: true,
		});

		console.log('HYDRATE TERMINAL RESPONSE', response);

		if (response.data.status === 1) {
			if (response.data.merchantID === '') {
				dispatch({
					type: 'hydrate_error',
				});
			} else {
				dispatch({
					type: 'hydrate_terminal',
					payload: response.data,
				});

				getLightbox({ opID: op });
			}
		} else {
			dispatch({
				type: 'hydrate_error',
			});
		}
	} catch (err) {
		console.log(err);
		dispatch({
			type: 'hydrate_error',
		});
		//window.location.href = `${baseURL()}/login`;
	}
	// }
};

const hello = () => {
	console.log('Hello there');
};

const getLightbox = async ({
	buttonColor,
	customerID,
	merchantID,
	enpartialpayment,
	opID,
}) => {
	const options = {
		method: 'POST',
		headers: { 'content-type': 'application/x-www-form-urlencoded' },
		data: qs.stringify({
			method: 'openLightbox',
			params: `{}`,
		}),
		withCredentials: true,
		url:
			!process.env.NODE_ENV || process.env.NODE_ENV === 'development'
				? 'https://brandonshepherd.cpteller.com/api/onetaxapi.cfc'
				: `https://${window.location.hostname}/api/onetaxapi.cfc`,
	};


	const intellipayResponse = await axios(options);

	if (!intellipayResponse.data.session) {
		const hydrateTerminalResponse = await axios({
			method: 'post',
			url: `${baseURL()}`,
			data: qs.stringify({
				method: 'hydrateTerminal',
				opID,
			}),
		});

		const response = await axios(options);
		console.log('GET LIGHTBOX RESPONSE', response);

		if (document.getElementById('intellipay-lightbox') === null) {
			var rg = document.createRange();
			document.documentElement.appendChild(
				rg.createContextualFragment(intellipayResponse.data.lightbox)
			);
		}

		window.intellipay.initialize();

		// window.intellipay.auth.enpartialpayment = enpartialpayment;
		//window.intellipay.auth.isCustPortal = true;
		window.intellipay.setItemLabel('account', 'Account');
		window.intellipay.enable("phone");
		// window.intellipay.disable("account");
		window.intellipay.enable("phone");

		window.intellipay.setItemBackgroundColor('button', buttonColor);
	} else {
		if (document.getElementById('intellipay-lightbox') === null) {
			var rg = document.createRange();
			document.documentElement.appendChild(
				rg.createContextualFragment(intellipayResponse.data.lightbox)
			);
		}

		window.intellipay.initialize();

		// window.intellipay.auth.enpartialpayment = enpartialpayment;
		//window.intellipay.auth.isCustPortal = true;
		window.intellipay.auth.isFullAccount = true;
		window.intellipay.setItemLabel('account', 'Account');
		window.intellipay.enable("phone");
		// window.intellipay.disable("account");
		window.intellipay.setItemBackgroundColor('button', buttonColor);
	}
};

export const { Provider, Context } = createDataContext(
	reducer,
	{
		hydrateTerminal,
		refreshLightboxAndOpen
	},
	{
		merchant: {
			logoURL: '',
			merchantID: '',
			merchantName: '',
			accountLabel: '',
			searchAccountStrict: '',
			parcelLabel: '',
			physicalAddressLabel: '',
			visibleFilters: ['status', 'type', 'year'],
			customDisclaimer : null,
			customerAddressInSearch : false,
			customSearchTipDescription : null,
			enableCoris:false,
			amountEditable: false,
			breakdownBaseTaxInterestAndFees: false,
		},
		appLoading: true,
		opIDValid: false,
		hydrateError: false,
	}
);
